(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kw-delivery-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-delivery-estimate')) {
    customElements.define(
      'kw-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10);
          const max = parseInt(this.dataset.max, 10);
          if (Number.isNaN(min) || Number.isNaN(max)) return;
          const fmt = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' });
          const at = (days) => {
            const d = new Date();
            d.setDate(d.getDate() + days);
            return fmt.format(d);
          };
          this.innerHTML = '';
          const label = document.createElement('span');
          label.textContent = 'Delivery by ';
          const strong = document.createElement('strong');
          strong.textContent = `${at(min)} – ${at(max)}`;
          this.append(label, strong);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
